import { render, staticRenderFns } from "./ComplaintReportFilter.vue?vue&type=template&id=2f1e0a6a&"
import script from "./ComplaintReportFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports